export const SHOW_MODAL = 'activity_types_form_modal_show';
export const HIDE_MODAL = 'activity_types_form_modal_hide';
export const RESET_MODAL_STATE = 'activity_types_form_modal_reset_state';
export const STORE_FORM_DATA = 'activity_types_form_store_form_data';
